import { AxiosRequest } from "../../../Url";
import { parseGridState } from "../../Sections/ElementsSections/SectionDocuments/DocumentsConsts";
import { defaultFieldInfo, getRightsData } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { getParamColumnsOptions, parseColumns, ParsedColumn } from "../GridTools/parseColumnTools";
import { EditStyle, MultiCheckState, ParamSetOption } from "../../Tools/ProjectX";
import { createGrid, createRecordSource, mfDelete, mfEdit } from "../rcsgrid";
import smetaAxios from "../../../SmetaAxios";

const cfgIDFieldName = "$CfgID";

enum ClsCode {
  Hidden = 1,
  Locked = 2,
}

export async function clsBookGrid(grid: createGrid, source: createRecordSource, props, data) {
  const getClsCodeValue = (option: number) => {
    const recordInfo = source.getRecordInfo();
    if (recordInfo) {
      if (option === ClsCode.Hidden) return recordInfo.hidden;
      if (option === ClsCode.Locked) return recordInfo.locked;
    }
    return false;
  };

  const currentCodeIsConfig = () => {
    return source.getFieldTextSync("ID") < 0;
  };

  source.onHandleRequest = handleRequest(props);
  source.caseSensitive = false;
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;
  await source.open();
  if (props.KeyField) source.setKeyFieldName(props.KeyField);
  const keyFieldName = source.getKeyFieldName();
  if (!keyFieldName) source.setKeyFieldName("Code");

  const codeField = source.fields[source.getFieldIndex("Code")];
  let columns = {
    title: [
      {
        fieldName: "ID",
        title: "Ключ",
        width: 70,
        level: 0,
        hide: true,
        fieldInfo: { ...defaultFieldInfo, EditStyle: EditStyle.ReadOnly },
      },
      {
        fieldName: "Code",
        title: "Код",
        width: codeField ? codeField.displayWidth * 15 : 120,
        level: 0,
        fixed: true,
        fieldInfo: {
          ...defaultFieldInfo,
          options: getParamColumnsOptions(ParamSetOption.Fixed),
          editMask: data.json?.Mask,
        },
      },
      {
        fieldName: "$CheckBoxx",
        title: "Множественный выбор",
        type: "3",
        width: 21,
        level: 0,
        hide: !props.MultiSel,
        fieldInfo: {
          ...defaultFieldInfo,
          multiCheckSet:
            MultiCheckState.Unchecked +
            MultiCheckState.Checked +
            MultiCheckState.UpArrow +
            MultiCheckState.DownArrow +
            MultiCheckState.Reject,
          EditStyle: EditStyle.Check,
          Image: 21,
          NoTitle: true,
        },
      },
      {
        fieldName: "Name",
        title: "Наименование",
        width: 300,
        level: 0,
        fieldInfo: { ...defaultFieldInfo },
      },
    ],
  };

  //парсинг полей запроса GetTableLayout
  if (data.json) {
    source.rights = getRightsData(data.json.Rights);
    let state;
    if (data.json.State) {
      state = data.json.State;
    }
    if (data.json.Columns && data.json.Columns.State) {
      state = data.json.Columns.State;
    }

    if (state) {
      state = parseGridState(state);
      source.setGridState(state);
    }
    //TODO сделать аналог function ResetClientGrid(Project: IClientProject; Grid: TClientGrid; Params: TXMLNodes; CheckColumn: TCheckColumnProc = nil): Boolean;
    columns = parseColumns(data.json, { inputColumns: columns });
    grid.setColumns(columns);
  } else grid.setColumns(columns);

  grid.MultiCLsSelect = props.MultiSel ? true : false;
  const selection = {};
  if (props.Selection) {
    const arrSelection = props.Selection.split(",");
    arrSelection.forEach((item) => {
      selection[item.match(/\d+/)[0]] = item;
    });
  }
  grid.ClsSelection = selection;

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async function (source) {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
  }

  grid.canModify = (flag: number, column: ParsedColumn | undefined, grid: createGrid) => {
    if (!grid.localCanModify(flag, column, grid)) return false;
    if (getClsCodeValue(ClsCode.Locked)) return false;
    if (currentCodeIsConfig() || Number(source.getFieldTextSync(cfgIDFieldName)) !== 0) {
      if (flag === mfDelete) return false;
      if (flag === mfEdit) return column?.fieldName !== "Code";
    }
    return true;
  };

  grid.setImageFields(["ID", "Image"]);
  source.booksGetImage = (value, field): string | number => {
    if (field === "Image") return value;
    if (currentCodeIsConfig()) return 3;
    if (getClsCodeValue(ClsCode.Locked)) return 4;
    if (Number(source.getFieldTextSync(cfgIDFieldName)) !== 0) return 2;
    return "";
  };

  await grid.setSource(source);

  source.onRecordCollapsed = async (event) => {
    const recordIndex = event.currentTarget !== undefined ? event.currentTarget.getAttribute("recordindex") : event;
    await smetaAxios.get("RecordCollapsed", {
      prefix: props.Module,
      params: { SectionID: props.SectionID, ObjType: props.ObjType, RecordIndex: recordIndex },
      loadMask: true,
    });
    await grid.refreshSource("!");
    if (data.setCountRecords) data.setCountRecords(source.recordCount);
    return;
  };

  if (props.ID) {
    await grid.refreshSource(props.ID);
  } else await grid.refreshSource();
  await grid.updateGridSize();
  if (data.setCountRecords) data.setCountRecords(source.recordCount);
  if (data.setSelectedRecord) data.setSelectedRecord(source.getFieldTextSync("ID"));
}

function handleRequest(props) {
  return (request, loadCursor, wsm, subParams) => {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", props.ObjType)
      .set("SectionID", props.SectionID)
      .set("CanChangeActual", "1");
    if (wsm) params.set("WSM", "1");
    if (subParams) {
      const sParams = Object.entries(subParams);
      sParams.forEach(([key, value]) => {
        params.set(key, value);
      });
    }
    return AxiosRequest(loadCursor !== undefined ? loadCursor : true, params, request);
  };
}
